import TagManager from 'react-gtm-module';

interface UseGoogleTagManagerHandler {
  initialize: () => void;
}

const useGoogleTagManager = (): UseGoogleTagManagerHandler => {
  const tagManagerArgs = {
    gtmId: process.env.GOOGLE_TAG_MANAGER_PUBLIC_KEY,
  };

  const initialize = () => {
    TagManager.initialize(tagManagerArgs);
  };

  return { initialize };
};

export default useGoogleTagManager;
